import { useEffect, useRef, useState } from 'react';

const LastUpdated = () => {
    const [timeAgo, setTimeAgo] = useState('');
    const loadTime = useRef<Date>(new Date());

	const reloadPage = () => location.reload();

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
			const diffInSeconds = Math.floor((now.getTime() - loadTime.current.getTime()) / 1000);

            let output = '';
            if (diffInSeconds < 60) {
                output = `${diffInSeconds} second${
                    diffInSeconds !== 1 ? 's' : ''
                } ago`;
            } else if (diffInSeconds < 3600) {
                const mins = Math.floor(diffInSeconds / 60);
                output = `${mins} minute${mins !== 1 ? 's' : ''} ago`;
            } else if (diffInSeconds < 86400) {
                const hours = Math.floor(diffInSeconds / 3600);
                output = `${hours} hour${hours !== 1 ? 's' : ''} ago`;
            } else {
                const days = Math.floor(diffInSeconds / 86400);
                output = `${days} day${days !== 1 ? 's' : ''} ago`;
            }

            setTimeAgo(output);
        }, 1000); // update every second

        return () => clearInterval(interval); // clean up on unmount
    }, []);

    return (
		<div className='w-80 ml-auto flex flex-wrap justify-end'>
			<div className="bg-gray-200 rounded-3xl w-60 text-xs text-gray-800 px-5 py-2 text-center">
				Last updated: {timeAgo}
			</div>
			<button onClick={reloadPage} className='ml-2' type='button'>
				<img alt='reload' src='/assets/shared/reload.svg' />
			</button>
		</div>
    );
};

export default LastUpdated;
